<template>
  <div class="row">
    <div class="col-md-12">
      <menu-link-form :route="route" @on-submit="onLinkSubmit"></menu-link-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import MenuLinkForm from './MenuLinkForm.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      MenuLinkForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        linkModel: {},
        link: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onLinkSubmit (model, isValid) {
        this.linkModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MenuLinks/MenuLinkEdit.vue